export interface PersonalInfoType {
    id?: number;
    contact_id?: number;
    first_name?: string;
    last_name?: string|null;
    email?: string;
    mobile?: string;
    landline?: string | null;
    address?: string;
    city?: string;
    post_code?: string;
    profile_image?: string | null;
    created_by?: number;
    created_at?: string;
    updated_at?: string;
}


// to single object maping
export const mapPersonalInfoType = (data: any): PersonalInfoType => {
    if (!data) {
        throw new Error('Invalid Data')
    }
    const res: PersonalInfoType = {
        id: data.id,
        contact_id: data.contact_id,
        first_name: data.first_name,
        last_name: data.last_name||null,
        email: data.email,
        mobile: data.mobile,
        landline: data.landline,
        address: data.address,
        city: data.city,
        post_code: data.post_code,
        profile_image: data.profile_image,
        created_by: data.created_by,
        created_at: data.created_at,
        updated_at: data.updated_at,
    }
    return res;
}

// maping list objects
export const mapPersonalInfoTypes = (data: any[]): PersonalInfoType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }
    return data.map(mapPersonalInfoType);
}